import React from 'react';
import { ClientContext } from './ClientContext';

export const useClient = () => {
  const client = React.useContext(ClientContext);
  return client;
};
